import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-print-legend',
    styleUrls: ['../../sharedStyles/base.scss'],
    templateUrl: './print-legend.component.html'
})
export class PrintLegendComponent extends BaseComponent {
    // @ViewChild('legendPreview') private readonly legendPreviewRef: ElementRef<HTMLDivElement>;

    constructor(
        _vcr: ViewContainerRef
        // private layerService: LayerService,
        // private printService: PrintService,
    ) {
        super(_vcr, true);
    }

    legendLayers: any[];
    legendTable: any[];
    maxRows: number;
    warning: string;
    optimalTableWidth: number;
    legendConfigOptions: {
        //height of the legend image in pixels. Will be multiplied by 'scale' property.
        height: number;
        //width of the legend image in pixels. Will be multiplied by 'scale' property.
        width: number;
        //number passed in to html2canvas to scale the legend image.
        scale: number;
        //styles to be applied to the legend via ng-style.
        styles: any;
        //max number of vertical rows to display before creating a new column in the legend.
        maxRows: number;
    };

    buildTable() {
        // this.legendTable = [];
        // let i = _.clone(this.maxRows);
        // if (this.maxRows === 0) {
        //     return;
        // }

        // if (this.legendLayers.length === 0) {
        //     this.warning = 'No layers are currently selected to display in your legend. You may continue without selecting any layers,' +
        //         ' toggle layers as visible, or add a layer to your map and try printing again.';
        //     return;
        // }

        // // this.warning = this.legendLayers.length <= 20 ?
        // //     undefined :
        // //     'Legends with more than 20 layers may cause layers to overlap or get cut off.';

        // for (const legendLayer of this.legendLayers) {
        //     const layer = {
        //         displayName: legendLayer.displayName,
        //         originalLayer: legendLayer
        //     };

        //     if (this.legendTable.length < this.maxRows) {
        //         this.legendTable.push({
        //             columns: [layer]
        //         });
        //     } else if (this.legendTable.length === this.maxRows) {
        //         this.legendTable[(this.maxRows - i)].columns.push(layer);
        //         if (i === 0) {
        //             i++;
        //         } else if (i === 1) {
        //             i = _.clone(this.maxRows);
        //         } else if (i <= this.maxRows) {
        //             i--;
        //         }
        //     }
        // }

        // this.updateOptimalTableWidth();
    }

    // getLegendImage(scaled?) {
    //     var el = this.legendPreviewRef,
    //         options = scaled ? { scale: this.legendConfigOptions.scale } : {},
    //         svgElem,
    //         promises: Promise<any>[];

    //     //convert svgs to canvas element so it can be captured by html2canvas
    //     svgElem = el.nativeElement.getElementsByTagName('svg');

    //     for (let node of svgElem) {
    //         if (node) {
    //             promises.push(new Promise(resolve => {
    //                 let canvas: HTMLCanvasElement = document.createElement('canvas'),
    //                     parentNode = node.parentNode,
    //                     svg = parentNode.innerHTML;
    //                 svg = svg.replace(/(<!--[\s\S]*?-->)/g, '').replace(/(ng-[\S]+?=".+?")/g, '');
    //                 let renderCallback = () => {
    //                     parentNode.appendChild(canvas);
    //                     resolve();
    //                 };
    //                 // canvg(canvas, svg, { renderCallback: renderCallback });
    //             }));
    //         }
    //     };

    //     return Promise.all(promises).then(() => {
    //         for (var i = svgElem.length; i--;) {
    //             var parentNode = svgElem[i].parentNode;
    //             parentNode.removeChild(svgElem[i]);
    //         }

    //         // return this.legendImgService.getElementImage(el, options);
    //     });
    // }

    getLegendElement() {
        return document.getElementById('legendPreview');
    }

    updateOptimalTableWidth() {
        const columnMaxWidth = 400,
            maxSpaceNeeded = (this.legendTable[0].columns.length * columnMaxWidth);

        this.optimalTableWidth = this.legendConfigOptions.width <= maxSpaceNeeded ?
            this.legendConfigOptions.width : maxSpaceNeeded;
    }
}
